import { useState, useEffect, useContext, createContext } from 'react'
// import { Auth } from 'aws-amplify'
import Auth from '@aws-amplify/auth'

export const AuthContext = createContext()
export const useAuth = () => useContext(AuthContext)
export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [user, setUser] = useState()
  const [loading, setLoading] = useState(true)

  const getToken = async () => {
    const cognitoUser = await Auth.currentAuthenticatedUser()
    return cognitoUser.getSignInUserSession().getAccessToken().getJwtToken()
  }

  const setAuthData = cognitoUser => {
    const cognitoUserSession = cognitoUser.getSignInUserSession()
    setIsAuthenticated(true)

    const idToken = cognitoUserSession.getIdToken()
    // console.debug(idToken)

    const tokenIssuedAt = new Date(idToken.payload.iat * 1000)
    console.debug(`Token Issued At: ${tokenIssuedAt.toLocaleString()}`)

    // const tokenExpiration = new Date(idToken.payload.exp * 1000)
    // console.debug(`Token Expiration Time: ${tokenExpiration.toLocaleString()}`)

    // const tokenAuthTime = new Date(idToken.payload.auth_time * 1000)
    // console.debug(`Token Authentication Time: ${tokenAuthTime.toLocaleString()}`)
    // console.debug(Auth)

    setUser(cognitoUserSession.getIdToken().payload)
    // console.debug('AuthContext:setAuthData: Set User, user = ', isAuthenticated)
  }

  const checkUser = async () => {
    try {
      // console.debug('AuthContext:checkUser: start')
      const cognitoUser = await Auth.currentAuthenticatedUser()

      if (cognitoUser && !isAuthenticated) {
        setAuthData(cognitoUser)
        // console.debug(cognitoUser)
      }
    } catch (err) {
      console.debug('AuthContext:checkUser:error: ', err)
      // console.debug(Auth)
    }
    // console.debug('AuthContext:checkUser: Setting loading=false, isAuthenticated = ', isAuthenticated)
    setLoading(false)
  }
  useEffect(() => {
    // console.debug('AuthContext: useEffect')
    checkUser()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const logout = async () => {
    console.debug('AuthContext: Signing Out')
    Auth.signOut()
    setIsAuthenticated(false)
    setUser(null)
  }

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        user,
        loading,
        getToken,
        checkUser,
        setAuthData,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}
